import { destroy, init, refresh } from "./src/js/index-esm.js"
const tocbot = { destroy, init, refresh }

export { destroy, init, refresh }
export default tocbot
